import React from 'react';
import PropTypes from 'prop-types';
import { Image } from './screenimage.style';

// CloudPouch 2.0 screen served as-is from static/screens/: a plain <img> with
// a 800/1600 srcset, so the files are never re-encoded by the build. The
// width/height attributes (the 1600 px file's size) reserve the box before the
// file loads, so they must match the image's own proportions.
const ScreenImage = ({ name, alt, sizes, width, height }) => (
  <Image
    src={`/screens/${name}-800.webp`}
    srcSet={`/screens/${name}-800.webp 800w, /screens/${name}-1600.webp 1600w`}
    sizes={sizes}
    width={width}
    height={height}
    loading="lazy"
    decoding="async"
    alt={alt}
  />
);

ScreenImage.propTypes = {
  name: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  sizes: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
};

ScreenImage.defaultProps = {
  width: 1600,
  height: 1000,
};

export default ScreenImage;
